import DOMPurify from 'dompurify'

const sanitizer = (ALLOWED_TAGS, ALLOWED_ATTR) => html => DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR })

const sanitizeHtml = sanitizer(['p', 'br', 'span', 'em', 'strong', 'ul', 'li', 'ol', 'sup', 'sub', 'div'], ['style'])
const cleanHtml = sanitizer([], [])


const removeLinebreaks = text => text.replace(/&nbsp;/g, '')
const decodeLowerThan = text => text.replace(/&lt;/g, '<')
const decodeGraterThan = text => text.replace(/&gt;/g, '>')

const handleTags = (text, openScriptTag, closeScriptTag, signToOpen, signToClose) => {
	const openTagCleanedText = text.replace(openScriptTag, signToOpen)
	return openTagCleanedText.replace(closeScriptTag, signToClose)
}

const cleanScriptsTags = text => {
	let cleanedText = handleTags(text, /<sup>/g, /<\/sup>/g, '^(', ')')
	cleanedText = handleTags(cleanedText, /<sub>/g, /<\/sub>/g, '_(', ')')
	return cleanedText
}

const htmlToPlainText = html => [cleanScriptsTags, cleanHtml, removeLinebreaks, decodeLowerThan, decodeGraterThan].reduce((text, func) => func(text), html)

export default sanitizeHtml
export { htmlToPlainText }
